import styles from './style.postcss';
import classnames from 'classnames';

import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import PropTypes from 'prop-types';

class CourseProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAtScrollMinX: true,
      isAtScrollMaxX: false,
    };
    this._onScrollStart = this._onScrollStart.bind(this);
    this._onScrollEnd = this._onScrollEnd.bind(this);
  }

  _renderEventDot(eventDate, eventPercentage, eventContent = '', eventType = '', index) {
    const percentage = eventPercentage;
    const style = (this._calculateProgress() <= 0 ||
        this._calculateProgress() < percentage) ?
          { left: `calc(${percentage}% - 10px)` } :
          { left: `calc(${percentage}% - 10px)`, backgroundColor: '#0087e6' };
    const whiteDotStyle = (this._calculateProgress() <= 0 ||
        this._calculateProgress() < percentage) ?
          { backgroundColor: '#a4a4a4' } :
          { backgroundColor: 'white' };
    const toolTipClassName = classnames(
      { [styles.CourseProgressBar_eventDots_tooltip]: percentage <= 90 && percentage >= 10 },
      { [styles.CourseProgressBar_eventDots_rightTooltip]: percentage > 90 },
      { [styles.CourseProgressBar_eventDots_leftTooltip]: percentage < 10 }
    );

    return <div className={styles.CourseProgressBar_eventDots}
        style={style}
        key={`${eventDate}-${index || eventType}`}>
      {
        eventType === 'progressTest' ?
          <div className={styles.CourseProgressBar_eventDots_whiteDots} style={whiteDotStyle} /> :
          ''
      }
      {
        eventContent !== '' ?
          <span className={toolTipClassName} >
            {eventContent}<br />
            {eventDate}
          </span> :
          ''
      }
    </div>;
  }

  _renderHighLightEventDots() {
    const hightLightEvents = this.props.highLightEvents || [];
    return hightLightEvents.map((event, index) =>
      this._renderEventDot(event.date, event.percentage, event.content, event.type, index)
    );
  }

  _renderStartEventDot() {
    return this._renderEventDot(
      this.props.startEvent.date,
      this.props.startEvent.percentage,
      this.props.startEvent.content,
      'startEvent');
  }

  _renderEndEventDot() {
    return this._renderEventDot(
      this.props.endEvent.date,
      this.props.endEvent.percentage,
      this.props.endEvent.content,
      'endEvent');
  }

  _getProgressBarStyle() {
    const progressWidth = `${this._calculateProgress()}%`;
    return { width: progressWidth };
  }

  _calculateProgress() {
    return this.props.currentEvent.percentage;
  }

  _renderCurrentTooltip() {
    let lastCurrentStyle = {};
    if (this.props.currentEvent.percentage > 90) {
      lastCurrentStyle = { left: '-77px' };
    }

    if (this.props.currentEvent.percentage < 10) {
      lastCurrentStyle = { left: '-20px' };
    }

    return this._calculateProgress() > 0 ?
      <div>
        <span className={styles.CourseProgressBar_currentSessionLine_tooltip}
            style={lastCurrentStyle}>
          {this.props.currentEvent.content}<br />
          <time dateTime={this.props.currentEvent.date}>
            {this.props.currentEvent.date}
          </time>
        </span>
      </div> :
      '';
  }

  _onScrollStart() {
    this.setState({
      isAtScrollMinX: false,
      isAtScrollMaxX: false,
    });
  }

  _onScrollEnd(_iScroll) {
    const newState = {
      isAtScrollMinX: false,
      isAtScrollMaxX: false,
    };
    if (_iScroll.x === 0) {
      newState.isAtScrollMinX = true;
    } else if (_iScroll.x === _iScroll.maxScrollX) {
      newState.isAtScrollMaxX = true;
    }
    if (newState.isAtScrollMinX !== this.state.isAtScrollMinX ||
        newState.isAtScrollMaxX !== this.state.isAtScrollMaxX) {
      this.setState(newState);
    }
  }

  render() {
    let courseProgressBarNode;
    return <div className={
          classnames(styles.CourseProgressBar_container, this.props.className)}>
      <ReactIScroll className={styles.CourseProgressBar}
          iScroll={iScroll}
          options={{
            bounce: false,
            scrollX: true,
            scrollY: false,
            scrollbars: true,
            interactiveScrollbars: true,
            eventPassthrough: true,
            keyBindings: true,
          }}
          ref={(node) => { courseProgressBarNode = node; }}
          onScrollStart={this._onScrollStart}
          onScrollEnd={this._onScrollEnd}>
        <div className={styles.CourseProgressBar_inner}
            onMouseDown={() => {
              const wrapper = courseProgressBarNode.getIScroll().wrapper;
              wrapper.classList.add(styles.__moving);
            }}
            onMouseUp={() => {
              const wrapper = courseProgressBarNode.getIScroll().wrapper;
              wrapper.classList.remove(styles.__moving);
            }}>
          <div className={styles.CourseProgressBar_basicBar}>
            <div className={styles.CourseProgressBar_progressBar}
                style={this._getProgressBarStyle()}>
              <div className={styles.CourseProgressBar_currentSessionLine}>
                {this._renderCurrentTooltip()}
              </div>
            </div>
            {this._renderStartEventDot()}
            {this._renderHighLightEventDots()}
            {this._renderEndEventDot()}
          </div>
          {this.props.children}
        </div>
      </ReactIScroll>
      <div className={classnames(styles.CourseProgressBar_leftNav, {
        [styles.__visible]: ! this.state.isAtScrollMinX,
      })}
          onClick={(ev) => {
            ev.preventDefault();
            courseProgressBarNode.withIScroll((_iScroll) => {
              // gte because x pos is negative for some reason
              if (_iScroll.x >= 0) return;
              _iScroll.scrollBy(50, 0, 300, iScroll.utils.ease.circular);
            });
          }} />
      <div className={classnames(styles.CourseProgressBar_rightNav, {
        [styles.__visible]: ! this.state.isAtScrollMaxX,
      })}
          onClick={(ev) => {
            ev.preventDefault();
            courseProgressBarNode.withIScroll((_iScroll) => {
              if (_iScroll.x <= _iScroll.maxScrollX) return;
              _iScroll.scrollBy(- 50, 0, 300, iScroll.utils.ease.circular);
            });
          }} />
    </div>;
  }
}

CourseProgressBar.propTypes = {
  className: PropTypes.string,
  currentEvent: PropTypes.object.isRequired,
  startEvent: PropTypes.object.isRequired,
  endEvent: PropTypes.object.isRequired,
  highLightEvents: PropTypes.array,
  children: PropTypes.node,
};

export default CourseProgressBar;



// WEBPACK FOOTER //
// ./components/CourseProgressBar/index.jsx